import React from 'react';
var StateContext = React.createContext(null);
export var StateProvider = StateContext.Provider;
export var StateConsumer = StateContext.Consumer;
export default StateContext;
//# sourceMappingURL=state-context.js.map